import axios from "axios";

class Services {
    constructor() {}

    saveImg(serviceId, images) {
        const formData = new FormData();
        images.forEach((file, index) => {
            formData.append(`images[${index}]`, file, file.name);
        });

        return axios.post(`/api/v1/services/${serviceId}/images`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
    }

    get(params = {}) {
        console.log('params', params)
        return axios({
            url: '/api/v1/services',
            method: 'GET',
            params: params
        })
    }
}

export default Services;